module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAsCAMAAABIQohxAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF1dfW0ebc2Ori9PT0y9XQyNLN+fr66+vrzd3V4uLj6vPtz+LZ7/bx0dHR////3u7pNLPyVQAAAPBJREFUeNqc09uyhSAIAFDwlqbg///twWOW15fNQ9O0BqEg4DWSkwuUO5dLqBIooVKDpHIfyA04D4LvUVfwQ0p+M4AGUa6BAzNXqcB6BEl54B77yvc/3PIKeQPzwxfyLgo4f4BgD6DxAKcaadeVEtgd9CPYXQ0UAH+Ay+IeZHxxD4EItyBi98DXmnLX0QYbR1KpgiYaO0D3LEOYIOoH+ILuAyhj2/rIgDuIRB9wt3IewgeajPp64i4DyPpGsYfSsl+Wuq48PXViGODbeUsTcP2zkOYMGZpCb0zgGRxYaYHcAjIACeAVGIJ2vAPXbv4EGACLzzY5Uc3C9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/IL.png
// module id = Ui3i
// module chunks = 1